import { render, staticRenderFns } from "./OpportunityDetail-followup.vue?vue&type=template&id=2d4ced13&scoped=true"
import script from "./OpportunityDetail-followup.vue?vue&type=script&lang=js"
export * from "./OpportunityDetail-followup.vue?vue&type=script&lang=js"
import style0 from "./OpportunityDetail-followup.vue?vue&type=style&index=0&id=2d4ced13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ced13",
  null
  
)

export default component.exports